import { HighlightManager } from "./highlight.manager";
import { AppConfig } from "../config/WebApp.config";
import {  LogContext } from "./logger.context";
import { UserContext, WorkSpaceContext } from "@/infrastructure/context";

export class LoggerManager extends HighlightManager {
  private readonly logContext: LogContext;

  constructor() {
    super();

    const user = UserContext.getInstance().getUser();
    const workspace = WorkSpaceContext.getInstance().getWorkSpace();

    this.logContext = {
      environment: AppConfig.getInstance().SENTRY_ENVIRONMENT,
      version: AppConfig.getInstance().VERSION,
      brand: workspace
        ? {
            brand_name: workspace?.workspaceName,
            brand_key: workspace?.workspaceKey,
          }
        : null,
      user: user
        ? {
            username: user?.fullName,
            email: user?.email,
          }
        : null,
    };
  }

  public async info(message: string, data?: unknown): Promise<void> {
    this.logContext.data = data;
    console.info(message, this.logContext);
  }

  public async warn(message: string, data?: unknown): Promise<void> {
    this.logContext.data = data;
    console.warn(message, this.logContext);
  }

  public async error(message: string, error: Error, data?: unknown): Promise<void> {
    this.logContext.error = error;
    this.logContext.data = data;
    HighlightManager.setError(message, error, this.logContext as unknown as { [key: string]: string });
  }
}
